import { apiService } from "./apiService";
import { endpoints } from "@/config/endpoints";
import axios from "axios";
import { getCookieValue } from "@/helpers/helpers";

export default {
  registerWithEmailAndPassword(data) {
    return apiService.post(endpoints.users.register, data);
  },

  loginWithEmailAndPassword(data) {
    return apiService.post(endpoints.users.login, data);
  },

  completeTwoFactorLogin(data) {
    return apiService.post(endpoints.users.twoFactor.login, data);
  },

  getTwoFactorStatus() {
    return apiService.get(endpoints.users.twoFactor.status);
  },

  startTwoFactorSetup(data) {
    return apiService.post(endpoints.users.twoFactor.setup, data);
  },

  confirmTwoFactorSetup(data) {
    return apiService.post(endpoints.users.twoFactor.confirmSetup, data);
  },

  disableTwoFactor(data) {
    return apiService.post(endpoints.users.twoFactor.disable, data);
  },

  regenerateTwoFactorBackupCodes(data) {
    return apiService.post(
      endpoints.users.twoFactor.regenerateBackupCodes,
      data
    );
  },

  logout(token) {
    return apiService.post(endpoints.users.logout, {}, {
      headers: { Authorization: `Token ${token}` },
      timeout: 10000
    });
  },

  acceptInvitation({ email, ...data }) {
    return apiService.post(endpoints.acceptInvitation, data);
  },

  resendInvitation(userId) {
    return apiService.post(endpoints.resendInvitation, { user: userId });
  },

  changePassword(data) {
    return apiService.post(endpoints.users.changePassword, data);
  },

  resetPassword(data) {
    return apiService.post(endpoints.users.reset, data);
  },

  confirmResetPassword(data) {
    return apiService.post(endpoints.users.confirmReset, data);
  },

  getUserDetails() {
    return apiService.get(endpoints.users.me);
  },

  patchUserDetails(data) {
    return apiService.patch(endpoints.users.me, data);
  },

  postSubscriptionVoucher(payload) {
    return apiService.post(endpoints.subscriptionVouchers, {
      number: payload
    });
  },

  getGoogleOAuthAccounts() {
    return apiService.get(endpoints.googleOAuth);
  },

  postGoogleOAuthAccounts(token) {
    return apiService.post(endpoints.googleOAuth, { code: token });
  },

  postGoogleProfile(id, payload, params = {}) {
    return apiService.post(
      `${endpoints.gmbProfilePlaces}${id}/places/`,
      payload,
      { params }
    );
  },

  getLocationsImportStatus() {
    return apiService.get(endpoints.gmbLocationImports);
  },

  getLocationsImportReport(id) {
    return apiService.get(`${endpoints.gmbLocationImports}${id}/report/`, {
      responseType: "blob"
    });
  },

  getGoogleProfilePlaces(id) {
    return apiService.get(`${endpoints.gmbProfilePlaces}${id}/`);
  },

  deleteGoogleProfile(id) {
    return apiService.delete(`${endpoints.gmbProfilePlaces}${id}/`);
  },

  deleteGoogleAccount(id) {
    return apiService.delete(`${endpoints.googleOAuth}${id}/`);
  },

  deleteGoogleProfilePlaces(place_id, payload) {
    return apiService.delete(
      `${endpoints.gmbProfilePlaces}${place_id}/places/`,
      { data: payload }
    );
  },

  getGoogleInsights(payload, params) {
    const xlsxExport = params && params.file_type == "xlsx";
    return apiService.post(endpoints.gmbInsights, payload, {
      params,
      ...(xlsxExport && { responseType: "blob" })
    });
  },
  getGoogleInsightsOld(payload, params) {
    return apiService.post(endpoints.gmbInsightsOld, payload, { params });
  },
  getGoogleInsightsAsync(payload, params) {
    return apiService.post(endpoints.gmbInsightsExport, payload, { params });
  },

  retrieveSamlToken() {
    const csrfToken = getCookieValue("csrftoken_tmp");
    if (!csrfToken) {
      throw new Error("CSRF token not found");
    }
    return axios.get(
      `${window.location.origin}/api/v1${endpoints.samlTokenRetrieve}`,
      {
        headers: { "X-CSRFToken": csrfToken }
      }
    );
  }
};
